import type { LocalizedStatus } from '@common/types'
import { StatusType } from '@common/types'
import { MessagingChannelStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const channelStatusMessages = defineMessages({
  active: {
    defaultMessage: 'Active',
    description: 'channel status name',
  },
  inactive: {
    defaultMessage: 'Inactive',
    description: 'channel status name',
  },
  restricted: {
    defaultMessage: 'Restricted',
    description: 'channel status name',
  },
})

export function translateChannelStatus(intl: IntlShape, status: MessagingChannelStatus): string {
  switch (status) {
    case MessagingChannelStatus.ACTIVE:
      return intl.formatMessage(channelStatusMessages.active)
    case MessagingChannelStatus.INACTIVE:
      return intl.formatMessage(channelStatusMessages.inactive)
    case MessagingChannelStatus.RESTRICTED:
      return intl.formatMessage(channelStatusMessages.restricted)
  }
}

export function localizeChannelStatus(
  intl: IntlShape,
  status: MessagingChannelStatus,
): LocalizedStatus {
  switch (status) {
    case MessagingChannelStatus.ACTIVE:
      return {
        localized: intl.formatMessage(channelStatusMessages.active),
        status: StatusType.SUCCESS,
      }
    case MessagingChannelStatus.INACTIVE:
      return {
        localized: intl.formatMessage(channelStatusMessages.inactive),
        status: StatusType.INFO,
      }
    case MessagingChannelStatus.RESTRICTED:
      return {
        localized: intl.formatMessage(channelStatusMessages.restricted),
        status: StatusType.WARNING,
      }
  }
}
